import routes from '@/route_names'
export default {
  // data: function() {
  //   console.log(routes)
  //   return {
  //     routeNames: routes
  //   }
  // },
  methods: {
    routeContains(name) {
      return this.$router.currentRoute.matched.find(f => f.name === name)
    }
  }
}
